var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('MainLayout',[_c('router-view',{key:_vm.routerViewKey})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }